var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { Icon } from '@iconify/react';
var pathPrefix = process.env.NODE_ENV === 'development'
    ? ''
    : typeof window !== 'undefined'
        ? window.PATH_PREFIX
        : '';
export var NoDataPrompt = function () {
    return (_jsx("div", __assign({ className: "flex justify-center" }, { children: _jsxs("div", __assign({ className: "flex flex-col items-center h-96 justify-center gap-6 shadow rounded-lg bg-white dark:bg-gray-700 px-12 mt-6 text-sm" }, { children: [_jsx(Icon, { icon: "material-symbols:info-outline", width: 40, height: 40 }), _jsxs("p", __assign({ className: "text-center max-w-[560px]" }, { children: [_jsx("span", __assign({ className: "text-xl" }, { children: "The Parca server hasn't recieved any data yet!" })), ' ', _jsx("br", {}), _jsx("br", {}), "Please check the", ' ', _jsx("a", __assign({ href: "".concat(pathPrefix, "/targets"), className: "text-blue-500" }, { children: "targets" })), ' ', "page and ensure that the agents are configured correctly and sending data to the server.", _jsx("br", {}), _jsx("br", {}), "If you're still having trouble, please check out the", ' ', _jsx("a", __assign({ href: "https://www.parca.dev/docs/troubleshooting-parca-agent", className: "text-blue-500", target: "_blank", rel: "noreferrer" }, { children: "documentation" })), ' ', "or join our", ' ', _jsx("a", __assign({ href: "https://discord.gg/ZgUpYgpzXy", className: "text-blue-500", target: "_blank", rel: "noreferrer" }, { children: "Discord" })), ' ', "for help."] }))] })) })));
};
